import { Injectable } from '@angular/core';

import { OAuthService } from 'angular-oauth2-oidc';


@Injectable({
  providedIn: 'root',
 })
export class AuthServiceCustom {


  constructor(private oauthService: OAuthService) {

  }

  get userName(): string {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['preferred_username'];
  }

  get givenName(): string {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['given_name'];
  }

  get completeName(): string {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['name'];
  }
  get urlImg(): string {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['picture'];
  }

  get userEmail(): string {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['email'];
  }

  get tokenExpiration(): number{
    return this.oauthService.getAccessTokenExpiration();
  }

  get claims(): object {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims;
  }

  get idToken(): string {
    return this.oauthService.getIdToken();
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

}
